import AddMultipleAssigneeDropdown from 'components/CustomDropdown/AddMultipleAssigneeDropdown';
import moment from 'moment';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import BackButtonComponent from '../../../components/BackButtonComponent/BackButtonComponent';
import AddSingleMemberDropdown from '../../../components/CustomDropdown/AddSingleMemberDropdown';
import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import ButtonTextLoader from '../../../components/Loaders/ButtonTextLoader';
import Select from '../../../components/ReactSelectDropdown';
import { filterOption } from '../../../components/ReactSelectDropdown/ReactSelectDropdown';
import { ClearSearchButton } from '../../../components/Search/searchStyles';
import DatePicker from '../../../components/SingleDatePicker/SingleDatePicker';
import { PrimaryButton, RadiusButton } from '../../../styledComponents/buttons';
import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonText,
  Container,
  ContentHeader,
  FormAlert,
  InputField,
  InputLabel,
  InputTextArea,
  InputWithLabelSection,
  PageTitle,
  RedStar,
} from '../../../styledComponents/common';
import {
  ToggleButton,
  ToggleButtonRound,
} from '../../../styledComponents/invoice';
import { checkHtml, checkUrl } from '../../../utils/helper';
import TimeRangeComponent from '../../Timesheet/Daily/TimeRangeComponent';
import DefaultTaskLocationWarningModal from '../DefaultTaskLocationWarningModal';
// import AddLocationModal from './AddLocationModal';
import {
  AssigneeSection,
  InputSection,
  TimeRangeSection,
} from './createTaskStyles';
import TaskForm from './taskForm';

const CreateTask = ({
  isLoading,
  orgMembersList,
  officesShortList,
  addTaskLocationLoading,
  createdTaskInfo,
  locationsList,
  createdTaskLocationInfo,
  memberShortListIsLoading,
  getOrganizationMembersList,
  createTask,
  getTaskLocation,
  addTaskLocation,
  getOfficesShortList,
  getTaskType,
  taskTypeIsLoading,
  taskTypeList,
  getTaskDetails,
  taskDetails,
  clearTaskState,
  history,
  location,
  getMasterTask,
  isMasterTaskLoading,
  MasterTasks,
  getLocationTypeList,
  locationTypeList,
  getLocationTypeListLoading,
  getMaxTaskDuration,
  fetchedMaxTaskDuration,
}) => {
  const { t, i18n } = useTranslation();

  const [taskName, setTaskName] = useState('');
  const [taskOptions, setTaskOptions] = useState([]);

  const [selectedOffice, setSelectedOffice] = useState('');
  const [officeOptions, setOfficeOptions] = useState([]);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [assigneeOptions, setAssigneeOptions] = useState([]);
  const [requiresApproval, setRequiresApproval] = useState(false);
  const [taskDescription, setTaskDescription] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [taskLocationOptions, setTaskLocationOptions] = useState([]);
  // const [radiusInput, setRadiusInput] = useState(100);
  // const [isCustomRadius, setIsCustomRadius] = useState(false);
  const [startDate, setStartDate] = useState(
    moment(new Date()).add(5, 'minutes'),
  );
  const [endDate, setEndDate] = useState(moment(new Date()).add(65, 'minutes'));
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [selectedTaskType, setSelectedTaskType] = useState('');
  const [popupOpen, setPopupOpen] = useState(false);
  const [isSameLocationWarningModalOpen, setIsSameLocationWarningModalOpen] =
    useState(false);
  const [taskId, setTaskId] = useState(null);
  const [isCateringTask, setIsCateringTask] = useState(false);
  const [cateringMealName, setCateringMealName] = useState('');

  const [saveErrors, setSaveErrors] = useState({});
  const radiusOptions = [20, 50, 100];
  const [statusOptions, setStatusOptions] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [selectedTaskDuration, setSelectedTaskDuration] = useState(null);
  //max time duration
  const [maxTaskDuration, setMaxTaskDuration] = useState(null);
  const [isCustomTaskName, setIsCustomTaskName] = useState(false);
  const globalMaxTaskDurationMinutes = fetchedMaxTaskDuration?.max_task_duration
    ? parseFloat(fetchedMaxTaskDuration.max_task_duration) * 60
    : null;
  const effectiveMaxTaskDuration = isCustomTaskName
    ? globalMaxTaskDurationMinutes
    : maxTaskDuration || globalMaxTaskDurationMinutes;

  const getMasterTaskByLabel = label => {
    if (!MasterTasks || !label) return null;
    const normalizedLabel = label.trim().toLowerCase();
    return MasterTasks.find(task => {
      const taskName =
        i18n.language === 'en' ? task.name : task.arabic_name || task.name;
      return taskName && taskName.trim().toLowerCase() === normalizedLabel;
    });
  };

  const onStartDateChange = date => {
    let errors = { ...saveErrors };
    delete errors['timeDifferenceStartTime'];
    setSaveErrors(errors);
    setStartDate(date);
  };
  const onEndDateChange = date => {
    let errors = { ...saveErrors };
    delete errors['timeDifferenceEndTime'];
    setSaveErrors(errors);
    setEndDate(date);
  };

  useEffect(() => {
    getOfficesShortList();
    if (location.search) {
      const queryParsed = queryString.parse(location.search);
      if (queryParsed.id) {
        setTaskId(queryParsed.id);
        getTaskDetails({ task_id: queryParsed.id });
      }
      if (queryParsed.catering === 'true') {
        setIsCateringTask(true);
        setCateringMealName(queryParsed.meal_name || '');
      }
    }
    getTaskType();
    getMaxTaskDuration();
    return () => {
      clearTaskState();
    };
  }, []);

  useEffect(() => {
    getLocationTypeList();
  }, []);

  useEffect(() => {
    if (officesShortList && officesShortList.length === 1) {
      getOrganizationMembersList({ office_id: officesShortList[0].id });
      getTaskLocation({ office_id: officesShortList[0].id });
    }
    if (!taskId && officesShortList && officesShortList.length > 0) {
      setSelectedOffice({
        label: officesShortList[0].name,
        value: officesShortList[0].id,
      });
    }
    if (officesShortList && officesShortList.length > 0) {
      let newArr = [];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  useEffect(() => {
    if (
      selectedOffice &&
      selectedOffice.value &&
      officesShortList &&
      officesShortList.length > 1
    ) {
      getOrganizationMembersList({ office_id: selectedOffice.value });
      getTaskLocation({ office_id: selectedOffice.value });
    }
  }, [selectedOffice]);

  useEffect(() => {
    if (locationsList && locationsList.length > 0) {
      let newArr = [];
      locationsList.forEach(location => {
        newArr.push({
          label: location.name,
          value: location.id,
          ...location,
        });
      });
      setTaskLocationOptions(newArr);
    }
  }, [locationsList]);

  useEffect(() => {
    if (taskTypeList && taskTypeList.length > 0) {
      let newArr = [];
      if (i18n.language && i18n.language === 'en') {
        taskTypeList.forEach(type => {
          newArr.push({
            label: type.name,
            value: type.id,
          });
        });
      } else {
        taskTypeList.forEach(type => {
          newArr.push({
            label: type.arabic_name,
            value: type.id,
          });
        });
      }
      setStatusOptions(newArr);
    }
  }, [taskTypeList]);

  useEffect(() => {
    if (selectedTaskType) {
      getMasterTask({ master_task_id: selectedTaskType.value });
      setTaskName('');
    }
  }, [selectedTaskType]);

  useEffect(() => {
    if (MasterTasks && selectedTaskType) {
      const options = MasterTasks.map(task => ({
        label: task.name,
        value: task.id,
      }));

      setTaskOptions(options);
    }
  }, [MasterTasks, selectedTaskType]);

  useEffect(() => {
    if (taskId && taskDetails) {
      taskDetails.name && setTaskName(taskDetails.name);
      taskDetails.office &&
        taskDetails.office.id &&
        setSelectedOffice({
          label: taskDetails.office.name,
          value: taskDetails.office.id,
        });
      if (isCateringTask && taskDetails.required_start_date && taskDetails.required_end_date) {
        const start = moment(taskDetails.required_start_date);
        const end = moment(taskDetails.required_end_date);
        setStartDate(start);
        setStartTime(start.format('HH:mm:ss'));
        setEndDate(end);
        setEndTime(end.format('HH:mm:ss'));
      }
      if (taskDetails.assignees && taskDetails.assignees.length > 0) {
        let newArr = [];
        taskDetails.assignees.forEach((assignee, i) => {
          newArr.push({
            ...assignee,
            name: `${assignee.first_name ? assignee.first_name : ''} ${
              assignee.last_name ? assignee.last_name : ''
            }`.trim(),
          });
        });
        setSelectedAssignees(newArr);
      }
      if (taskDetails.location && taskDetails.location.id) {
        setSelectedLocation({
          label: taskDetails.location.name,
          value: taskDetails.location.id,
        });
      }
      if (taskDetails.description) {
        setTaskDescription(taskDetails.description);
      }
      if (taskDetails.task_type && taskDetails.task_type.id) {
        statusOptions.map((option, i) => {
          if (option.value === taskDetails.task_type.id) {
            setSelectedTaskType({
              label: option.label,
              value: option.value,
            });
          }
        });
      }
    }
  }, [taskDetails]);

  useEffect(() => {
    if (
      selectedOffice &&
      selectedOffice.label &&
      taskLocationOptions &&
      taskLocationOptions.length > 0
    ) {
      const officeLocations = taskLocationOptions?.filter(
        location =>
          location?.office?.id === selectedOffice?.value ||
          location?.office === selectedOffice?.value,
      );
      const newValidLocation = taskLocationOptions?.find(
        location => location?.id === createdTaskLocationInfo?.id,
      );

      const defaultLocation = officeLocations?.filter(
        location => location.name === selectedOffice?.label,
      );
      const initialLocation = taskLocationOptions?.filter(
        location => location?.id === taskDetails?.location?.id,
      );
      if (
        newValidLocation?.office?.id === selectedOffice?.value ||
        newValidLocation?.office === selectedOffice?.value
      ) {
        // do nothing
      } else if (taskId && initialLocation?.length > 0) {
        setSelectedLocation(initialLocation[0]);
      } else {
        if (defaultLocation?.length >= 1) {
          setSelectedLocation(defaultLocation[0]);
        } else if (officeLocations?.length >= 1) {
          setSelectedLocation(officeLocations[0]);
        } else {
          setSelectedLocation(taskLocationOptions[0]);
        }
      }
    }
  }, [taskLocationOptions]);

  useEffect(() => {
    if (createdTaskInfo && isSubmitted) {
      history.push({
        pathname: isCateringTask ? '/user/catering-task-report' : '/user/tasks',
        state: { from: 'create' },
      });
    }
  }, [createdTaskInfo]);

  // const onTaskNameChange = e => {
  //   let errors = { ...saveErrors };
  //   delete errors['taskName'];
  //   setSaveErrors(errors);
  //   setTaskName(e.target.value);
  // };

  // const onTaskNameChange = selectedOption => {
  //   let errors = { ...saveErrors };
  //   delete errors['taskName'];
  //   setSaveErrors(errors);
  //   if (selectedOption && selectedOption.__isNew__) {
  //     // Manually typed
  //     const newOption = {
  //       label: selectedOption.label,
  //       value: selectedOption.label, // Set same as label or generate a UUID if needed
  //     };
  //     setTaskName(newOption);
  //   } else if (selectedOption) {
  //     // Selected from dropdown
  //     setTaskName(selectedOption); // Store full object (with label + value)
  //   } else {
  //     // Cleared
  //     setTaskName('');
  //   }
  // };

  const onTaskNameChange = selectedOption => {
    let errors = { ...saveErrors };
    delete errors['taskName'];
    setSaveErrors(errors);

    const typedLabel = selectedOption?.label || selectedOption;
    const matchedMasterTask = getMasterTaskByLabel(typedLabel);
    const isNewCustomTask =
      (selectedOption && selectedOption.__isNew__) ||
      (typeof selectedOption === 'string' && !matchedMasterTask);

    if (matchedMasterTask) {
      setIsCustomTaskName(false);
      const option = {
        label: typedLabel,
        value: matchedMasterTask.id,
      };
      setTaskName(option);

      if (parseFloat(matchedMasterTask.default_task_duration) > 0) {
        const duration = parseFloat(matchedMasterTask.default_task_duration);
        const totalMinutes = Math.round(duration * 60);

        setSelectedTaskDuration(totalMinutes);

        if (
          matchedMasterTask.max_task_duration &&
          parseFloat(matchedMasterTask.max_task_duration) > 0
        ) {
          const maxMinutes = Math.round(
            parseFloat(matchedMasterTask.max_task_duration) * 60,
          );
          setMaxTaskDuration(maxMinutes);
        } else {
          setMaxTaskDuration(null);
        }

        const start = moment(
          `${startDate.format('YYYY-MM-DD')} ${startTime || '00:00:00'}`,
          'YYYY-MM-DD HH:mm:ss',
        );

        const newEnd = moment(start).add(totalMinutes, 'minutes');

        setEndTime(newEnd.format('HH:mm:ss'));
        setEndDate(newEnd);
      }
    } else if (isNewCustomTask) {
      setIsCustomTaskName(true);
      const newOption = {
        label: typedLabel,
        value: typedLabel,
      };
      setTaskName(newOption);
      setSelectedTaskDuration(null);
      setMaxTaskDuration(null);
    } else if (selectedOption) {
      setIsCustomTaskName(false);
      setTaskName(selectedOption);

      const selectedTask = MasterTasks.find(
        task => task.id === selectedOption.value,
      );

      if (selectedTask && parseFloat(selectedTask.default_task_duration) > 0) {
        const duration = parseFloat(selectedTask.default_task_duration);
        const totalMinutes = Math.round(duration * 60);

        setSelectedTaskDuration(totalMinutes);

        if (
          selectedTask.max_task_duration &&
          parseFloat(selectedTask.max_task_duration) > 0
        ) {
          const maxMinutes = Math.round(
            parseFloat(selectedTask.max_task_duration) * 60,
          );
          setMaxTaskDuration(maxMinutes);
        } else {
          setMaxTaskDuration(null);
        }

        const start = moment(
          `${startDate.format('YYYY-MM-DD')} ${startTime || '00:00:00'}`,
          'YYYY-MM-DD HH:mm:ss',
        );

        const newEnd = moment(start).add(totalMinutes, 'minutes');

        setEndTime(newEnd.format('HH:mm:ss'));
        setEndDate(newEnd);
      }
    } else {
      setIsCustomTaskName(false);
      setTaskName('');
      setSelectedTaskDuration(null);
      setMaxTaskDuration(null);
    }
  };


  const onOfficeChange = e => {
    setSelectedOffice(e);
  };

  const approvalToggle = () => {
    setRequiresApproval(!requiresApproval);
  };

  const handleAssignOrRemoveMember = (user, action) => {
    if (user && user.id) {
      let newArr = [...selectedAssignees];
      if (action === 'remove') {
        newArr = newArr.filter(member => member.id !== user.id);
      } else {
        newArr.push(user);
      }
      setSelectedAssignees(newArr);
    }
  };

  const handleAssignMember = user => {
    handleAssignOrRemoveMember(user, 'assign');
  };

  const handleRemoveMember = user => {
    handleAssignOrRemoveMember(user, 'remove');
  };

  const onTaskDescriptionChange = e => {
    let errors = { ...saveErrors };
    delete errors['taskDescription'];
    setSaveErrors(errors);
    setTaskDescription(e.target.value);
  };

  const onLocationChange = e => {
    setSelectedLocation(e);
  };

  // const handleStartTime = time => {
  //   if (time) {
  //     let errors = { ...saveErrors };
  //     delete errors['timeDifference'];
  //     setSaveErrors(errors);
  //     const start_time = time.replace(/ /g, '');
  //     setStartTime(moment(start_time, 'h:mmA').format('HH:mm:ss'));
  //   } else {
  //     setStartTime('');
  //   }
  // };

  const handleStartTime = time => {
    if (time) {
      let errors = { ...saveErrors };
      delete errors['timeDifference'];
      setSaveErrors(errors);
      const formattedTime = moment(time.replace(/ /g, ''), 'h:mmA').format(
        'HH:mm:ss',
      );
      setStartTime(formattedTime);

      if (selectedTaskDuration) {
        const newStart = moment(
          `${startDate.format('YYYY-MM-DD')} ${formattedTime}`,
          'YYYY-MM-DD HH:mm:ss',
        );
        const newEnd = moment(newStart).add(selectedTaskDuration, 'minutes');
        setEndTime(newEnd.format('HH:mm:ss'));
        setEndDate(newEnd);
      }
    } else {
      setStartTime('');
    }
  };

  const handleEndTime = time => {
    if (time) {
      let errors = { ...saveErrors };
      delete errors['timeDifference'];
      setSaveErrors(errors);
      const end_time = time.replace(/ /g, '');
      setEndTime(moment(end_time, 'h:mmA').format('HH:mm:ss'));
    } else {
      setEndTime('');
    }
  };

  const onTaskTypeChange = e => {
    setSelectedTaskType(e);
  };

  const popupToggle = () => {
    setPopupOpen(!popupOpen);
  };
  const popupToggleSameLocationWarningModal = () => {
    setIsSameLocationWarningModalOpen(!isSameLocationWarningModalOpen);
  };

  const handleSave = () => {
    if (checkError()) {
      if (selectedOffice && selectedOffice.value) {
        const start_date = moment(
          startDate.format('YYYY-MM-DD') + ' ' + startTime,
        );
        const end_date = moment(endDate.format('YYYY-MM-DD') + ' ' + endTime);
        let assigneeIds = [];
        if (selectedAssignees && selectedAssignees.length > 0) {
          selectedAssignees.forEach(element => {
            assigneeIds.push(element.id);
          });
        }
        const isUUID = value =>
          typeof value === 'string' &&
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
            value,
          );

        let payload = {
          name: typeof taskName === 'object' ? taskName.label : taskName,
          master_task_code:
            typeof taskName === 'object' && isUUID(taskName.value)
              ? taskName.value
              : null,
          office_id: selectedOffice.value,
          assignees: assigneeIds,
          description: taskDescription,
          location: selectedLocation.value,
          task_type: selectedTaskType.value,
          required_start_date: moment(start_date).format(
            'YYYY-MM-DDTHH:mm:ssZ',
          ),
          required_end_date: moment(end_date).format('YYYY-MM-DDTHH:mm:ssZ'),
        };
        if (isCateringTask) {
          payload.type = 'catering';
          if (cateringMealName) payload.meal_name = cateringMealName;
        }
        const officeLocation = officesShortList.find(
          office => office.id === selectedOffice.value,
        ).location;
        if (
          officeLocation.latitude === selectedLocation.latitude &&
          officeLocation.longitude === selectedLocation.longitude &&
          isSameLocationWarningModalOpen === false
        ) {
          setIsSameLocationWarningModalOpen(true);
          return;
        }
        createTask(payload);
        setIsSubmitted(true);
      }
    }
  };

  const checkError = () => {
    let saveErrors = {};
    let formIsValid = true;
    const taskNameValue =
      typeof taskName === 'object' ? taskName.label : taskName;

    if (!taskNameValue.trim()) {
      formIsValid = false;
      saveErrors['taskName'] = 'Task name is required';
    } else if (checkUrl(taskNameValue)) {
      formIsValid = false;
      saveErrors['taskName'] = 'Task name can not contain url.';
    } else if (checkHtml(taskNameValue)) {
      formIsValid = false;
      saveErrors['taskName'] = 'Invalid Task name';
    } else if (taskNameValue.length > 255) {
      formIsValid = false;
      saveErrors['taskName'] = 'Maximum length 255 characters';
    }
    if (selectedAssignees.length === 0) {
      formIsValid = false;
      saveErrors['selectedAssignees'] = 'Assignee is required';
    }
    if (checkUrl(taskDescription)) {
      formIsValid = false;
      saveErrors['taskDescription'] = 'Task description can not contain url.';
    } else if (checkHtml(taskDescription)) {
      formIsValid = false;
      saveErrors['taskDescription'] = 'Invalid Task description';
    } else if (taskDescription.length > 512) {
      formIsValid = false;
      saveErrors['taskDescription'] = 'Maximum length 512 characters';
    }
    if (!selectedTaskType?.value) {
      formIsValid = false;
      saveErrors['taskType'] = t('task_type_is_required');
    }

    if (!startDate) {
      formIsValid = false;
    }
    if (!startTime || !endTime) {
      formIsValid = false;
    }

    const startMoment = moment(
      startDate.format('YYYY-MM-DD') + ' ' + startTime,
    );
    const endMoment = moment(endDate.format('YYYY-MM-DD') + ' ' + endTime);
    const durationMs = endMoment.diff(startMoment);

    if (durationMs < 1) {
      formIsValid = false;
      saveErrors['timeDifferenceEndTime'] = t(
        'end_time_must_be_after_start_time',
      );
    } else if (!isCateringTask && durationMs < 1800000) {
      formIsValid = false;
      saveErrors['timeDifferenceEndTime'] =
        'Minmium 30 minutes time difference required';
    } else if (isCateringTask && durationMs < 120000) {
      formIsValid = false;
      saveErrors['timeDifferenceEndTime'] =
        'Minimum 2 minutes time difference required';
    } else if (
      effectiveMaxTaskDuration &&
      durationMs > effectiveMaxTaskDuration * 60 * 1000
    ) {
      formIsValid = false;
      saveErrors['timeDifferenceEndTime'] = `Task duration cannot exceed ${
        effectiveMaxTaskDuration / 60
      } hours`;
    }

    if (startMoment.diff(moment()) < 1) {
      formIsValid = false;
      saveErrors['timeDifferenceStartTime'] = t('past_time_cant_be_set');
    }

    setSaveErrors(saveErrors);
    return formIsValid;
  };

  return (
    <TaskForm
      {...{
        addTaskLocation,
        addTaskLocationLoading,
        createdTaskLocationInfo,
        endTime,
        getOfficesShortList,
        getTaskLocation,
        getLocationTypeList,
        locationTypeList,
        handleAssignMember,
        handleEndTime,
        handleRemoveMember,
        handleSave,
        handleStartTime,
        history,
        isLoading,
        isSameLocationWarningModalOpen,
        memberShortListIsLoading,
        officeOptions,
        officesShortList,
        onLocationChange,
        onOfficeChange,
        onTaskDescriptionChange,
        onTaskNameChange,
        onTaskTypeChange,
        orgMembersList,
        popupOpen,
        popupToggle,
        popupToggleSameLocationWarningModal,
        saveErrors,
        selectedAssignees,
        endDate,
        onEndDateChange,
        startDate,
        onStartDateChange,
        selectedLocation,
        selectedOffice,
        selectedTaskType,
        startTime,
        statusOptions,
        taskDescription,
        taskLocationOptions,
        taskName,
        taskOptions,
        setTaskOptions,
        isMasterTaskLoading,
      }}
      creating={true}
    />
  );
};

export default CreateTask;
